import { OmniElement, OmniStyleElement, html, css } from 'omni-ui';
import './campaign-winning-thoughtleader.js';
import './campaign-idea-generator-inputs.js';
import '../campaign-pinnable-cards.js';

OmniStyleElement.register();

/**
 * Class for Attention Calculator Multi Rec Module Element
 * @extends OmniElement
 */
export class IdeaGenerator extends OmniElement {
  /**
   * Attention Calculator Multi Rec Lit Properties
   * @property {Object} context - Values passed in from wrapper/router
   * @property {Object} savedData - Data already saved in the API
   * @property {Object} schema - Values passed in from wrapper/router
   */
  static get properties() {
    return {
      context: { type: Object },
      savedData: { type: Object },
      schema: { type: Object },
      generatedIdeas: { type: Object },
      ideaCards: { type: Object },
    };
  }

  static get styles() {
    return [
      super.styles,
      css`
        omni-tile {
          margin-bottom: 2.413rem;
        }
        .title-wrapper {
          margin-left: 2.286rem;
        }
        omni-tile.module-wrapper::part(body-slot) {
          padding: 2.413rem 2.857rem 1.429rem 0;
        }
      `,
    ];
  }

  /**
   * Sets up event listener for the 'recommendation-update' event when the component is connected.
   * @listens event:recommendation-update
   */
  connectedCallback() {
    super.connectedCallback();
    this.generatedIdeas = this.savedData?.generatedIdeas ?? {};
    this.ideaCards = this.savedData?.ideaCards ?? [];
  }

  /**
   * Handles the change event for idea generator generated ideas child component
   * @param {CustomEvent} e - The change event object that contains the generatedIdeas object to be saved
   */
  #handleIdeaChange = e => {
    this.generatedIdeas = e.detail.generatedIdeas;
    this.#dispatchModuleChange();
  };

  /**
   * Handles the change event for idea generator core idea cards child component
   * @param {CustomEvent} e - The change event object that contains the coreIdeas object to be saved
   */
  #handleIdeaCardChange = e => {
    this.ideaCards = e.detail.cards;
    this.#dispatchModuleChange();
  };

  #dispatchModuleChange = async () => {
    await this.updateComplete;

    const { uuid_module: moduleId } = this.context;
    const { generatedIdeas, ideaCards } = this;

    this.dispatchNewEvent('omni-module-changed', {
      detail: {
        moduleId,
        saveAction: () => this.save({ generatedIdeas, ideaCards }),
      },
    });
  };

  /**
   * @returns {html} Rendered HTML for the component
   */
  render() {
    return html` <omni-style>
      <omni-tile class="module-wrapper">
        <div class="title-wrapper">
          <div>
            <winning-thoughtleader
              .context=${this.context}
            ></winning-thoughtleader>
            <idea-generator-inputs
              .context=${this.context}
              .savedData=${this.savedData}
              .schema=${this.schema}
              @idea-generator-change=${this.#handleIdeaChange}
            ></idea-generator-inputs>
            <campaign-pinnable-cards
              .env=${this.env}
              .token=${this.token}
              .context=${this.context}
              .cards=${this.ideaCards ?? []}
              .schema=${this.schema}
              assistFieldId="coreIdea"
              @card-change=${this.#handleIdeaCardChange}
            >
            </campaign-pinnable-cards>
          </div>
        </div>
      </omni-tile>
    </omni-style>`;
  }
}

OmniElement.register('idea-generator', IdeaGenerator);
